import { app } from "modular-openscriptjs";
import { either, oneOf, formatThousand } from "../../helpers";

const h = app("h");
const gc = app("gc");

export default function MentionResult(suggestion, type, ...args) {
	switch (type) {
		case "@":
			let user = suggestion;
			return h.div(
				{
					class: "bg-white d-flex gap-3 mb-1 p-3 position-relative rounded shadow-sm",
					role: "button",
				},
				h.div(
					{ class: "" },
					h.ProfilePic(
						gc.user,
						h.call(() => {
							let path = gc.user?.value?.profile_photo_path;

							if (user?.id != gc.user?.id) {
								path = user?.profile_photo_path;
							}

							return h.img(
								{
									class: "rounded-circle d-block border",
									style: "max-width: 40px; height: auto",
									id: "user-profile-avatar",
								},

								either(
									path,
									{ src: path },
									{ src: "/assets/images/user-avatar.png" }
								)
							);
						})
					)
				),
				h.div(
					{ class: "col" },
					h.div(
						{ class: "d-flex flex-column gap-3" },
						h.div(
							{ class: "row p-0 justify-content-between" },
							h.div(
								{
									class: "col col-auto",
								},
								h.div(
									{ class: "m-0" },
									h.span(
										{ class: "fw-bold me-2" },
										user?.display_name
									),
									either(
										user?.is_business,
										() =>
											h.span(
												{ class: "text-info" },
												h.i({ class: "fas fa-shop" })
											),
										either(user?.is_verified, () =>
											h.span(
												{ class: "text-info" },
												h.i({
													class: "fas fa-circle-check",
												})
											)
										)
									)
								),

								h.div(
									{
										class: "overflow-ellipsis d-md-none m-0 form-text mt-1",
									},
									h.span(
										{ class: "text-secondary d-block" },
										"@",
										user?.username
									)
								),

								either(
									user?.is_business && user?.location,
									() => [
										h.div(
											{
												class: "d-flex gap-2 text-secondary m-0 fs-xsm",
											},
											h.span(
												{
													class: "text-secondary-subtle",
												},
												h.i({
													class: "fas fa-location-dot",
												})
											),
											h.span(
												oneOf(
													user?.shop_location
														?.readable_address,
													user?.location
												)
											)
										),
										h.div(
											{
												class: "d-flex gap-2 m-0 text-secondary fs-xsm",
											},
											h.span(
												h.i({ class: "fas fa-clock" })
											),
											either(
												user?.operating_hours
													?.is_opened,
												() => [
													{ class: "text-success" },
													h.span("Today"),
													h.span("●"),
													h.span(
														user?.operating_hours
															?.opens_at
													),
													h.span("—"),
													h.span(
														user?.operating_hours
															?.closes_at
													),
													h.span("●"),
													h.span(
														user?.operating_hours
															?.message
													),
												],
												() =>
													h.span(
														user?.operating_hours
															?.message
													)
											)
										),
									]
								)
							),
							h.div(
								{
									class: "col overflow-ellipsis d-none d-md-block p-0",
								},
								h.span(
									{ class: "text-secondary" },
									"@",
									user?.username
								)
							)
						)
					)
				),
				...args
			);

		case "#":
			let tag = suggestion;
			return h.div(
				{
					class: "bg-white d-flex gap-3 mb-1 p-3 rounded shadow-sm justify-content-between flex-wrap",
					role: "button",
				},
				h.span({ class: "fw-600" }, "#", tag?.name),
				h.div(
					{ class: "text-secondary" },
					formatThousand(tag?.usage_count ?? 0)
				),
				...args
			);
	}
}
